import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=18f54234"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=18f54234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports